export default "__VITE_ASSET__HdGXKgLA__"